import isNullOrUndefined from "_shared/_utilities/is-null-or-undefined";
import Guid from "_shared/guids/guid";
import EntityName from "legal-entities/entity-names/entity-name";
import UserEntityInfoSchema, {
  UserEntityInfoJSON,
  UserEntityInfoParams,
} from "users/information/entity-information/user-entity-info-schema";

/** Entity member user information */

export default class UserEntityInfo {
  public static readonly EXAMPLE = UserEntityInfo.create({
    entityId: Guid.generate(),
    entityName: EntityName.create("Test Entity"),
    isOfficer: false,
  });

  public static create(params: UserEntityInfoParams): UserEntityInfo {
    const parsed = UserEntityInfoSchema.validate(params);
    return new UserEntityInfo(parsed);
  }

  public static fromJSON(json: unknown): UserEntityInfo | null | undefined {
    if (isNullOrUndefined(json)) return json;
    const params = UserEntityInfoSchema.deserialize(json);
    return new UserEntityInfo(params);
  }
  public static fromJSONArray(jsonArray: unknown): UserEntityInfo[] | null | undefined {
    if (isNullOrUndefined(jsonArray)) return jsonArray;
    const deserializedArray: UserEntityInfoParams[] = UserEntityInfoSchema.deserializeArray(jsonArray);
    return deserializedArray.map((params) => new UserEntityInfo(params));
  }

  public readonly entityId: Guid;
  public readonly entityName: EntityName;
  public readonly isOfficer: boolean;

  public get id(): Guid {
    return this.entityId;
  }

  public constructor(params: UserEntityInfoParams) {
    const validatedParams = UserEntityInfoSchema.validate(params);
    this.entityId = validatedParams.entityId;
    this.entityName = validatedParams.entityName;
    this.isOfficer = validatedParams.isOfficer;
  }

  public toJSON(): UserEntityInfoJSON {
    return UserEntityInfoSchema.serialize(this);
  }

  public isEqualTo(other: UserEntityInfo): boolean {
    return this.entityId.isEqualTo(other?.entityId);
  }

  public toString(): string {
    return `UserEntityInfo (
      entityId: ${this.entityId.value}
      entityName: ${this.entityName.toString()}
      isOfficer: ${this.isOfficer}
    )`;
  }
}

export class InvalidUserEntityInfoError extends Error {
  constructor(public issues: unknown) {
    super(`Invalid user entity info.`);
  }
}
